<script setup>
import XlCard from '../xl/XlCard.vue';
import XlSkeleton from '../xl/XlSkeleton.vue';

/**
 * A session card before its session is here: SessionCard's own frame — the
 * date tile, the title, the time and meta lines, who it reaches and the way
 * in — with placeholders where the words go, so the list does not move when
 * the cards land (Sessions: a generic rows skeleton stood in for date-tiled
 * cards, and the page jumped as they replaced it).
 */
defineProps({
  // Varied, so a column of cards does not read as one slab.
  titleWidth: { type: String, default: '46%' },
  metaWidth: { type: String, default: '58%' },
});
</script>

<template>
  <XlCard class="session-card-sk" data-testid="session-card-loading">
    <div class="session-card-sk__row">
      <XlSkeleton width="58px" height="64px" radius="14px" class="session-card-sk__sk" />
      <div class="session-card-sk__main">
        <XlSkeleton :width="titleWidth" height="0.95em" radius="7px" class="session-card-sk__line session-card-sk__line--title" />
        <XlSkeleton width="74px" height="0.85em" radius="6px" class="session-card-sk__line session-card-sk__line--time" />
        <XlSkeleton :width="metaWidth" height="0.8em" radius="6px" class="session-card-sk__line session-card-sk__line--meta" />
      </div>
      <div class="session-card-sk__side">
        <XlSkeleton width="72px" height="24px" radius="99px" class="session-card-sk__sk" />
        <XlSkeleton width="150px" height="36px" radius="99px" class="session-card-sk__sk" />
      </div>
      <XlSkeleton width="16px" height="16px" radius="4px" class="session-card-sk__sk" />
    </div>
  </XlCard>
</template>

<style scoped>
/* SessionCard's frame, kept in step with it. */
.session-card-sk { margin-bottom: 12px; padding: 0; overflow: hidden; }
.session-card-sk__row { display: flex; align-items: center; gap: 18px; padding: 18px 20px; }
.session-card-sk__main { display: flex; flex-direction: column; flex: 1; min-width: 0; }
/* Each line the height of the card's own line box, as measured in the browser
   (title 22px, time 19px, the meta line 18px) — the card is then the same
   height as the one it stands for, and the cards under it do not move when
   the rows land. The bar is centred in it at that text's size. */
.session-card-sk__line { display: flex; align-items: center; }
.session-card-sk__line--title { font-size: 16.5px; height: 22px; }
.session-card-sk__line--time { margin-top: 5px; font-size: 14px; height: 19px; }
.session-card-sk__line--meta { margin-top: 3px; font-size: 13px; height: 18px; }
.session-card-sk__side { display: flex; flex-direction: column; align-items: flex-end; gap: 6px; flex: 0 0 auto; }
.session-card-sk__sk { width: auto; flex: 0 0 auto; }
</style>
